export class Download {

	constructor(node, clientCode) {
		this.wrapper = node;
		this.node = node.querySelector('[data-configurator-download]');
		this.clientCode = clientCode;
		this.payload = this.getPayload();
		this.addListener();
	}

	addListener() {
		this.node.addEventListener('click', this.onClick.bind(this));
	}

	getPayload() {
		return {
			ID: productSheet.idDoc,
			clientCode: this.clientCode,
			metadata: this.metadata
		};
	}

	onClick() {
		const fancy = this.wrapper.querySelector('[data-configurator-fancy]');
		fancy.classList.add('loading');
		this.getThumb();
	}

	getThumb() {
		let conf = this.wrapper.querySelector('#configurationId').getAttribute('value');
		const i = conf.indexOf('_');
		conf = conf.substr(i + 1);
		window.ResolveThumbAnd(conf, this.thumbLoaded.bind(this));
	}

	thumbLoaded() {
		const image = this.wrapper.querySelector('#configurationThumb').getAttribute('value');
		this.payload.img = image;
		this.postData();
	}

	postData() {
		fetch('/api/configurator/products/confpdf?state=true', {
			method: 'post',
			cache: 'no-cache',
			credentials: 'include',
			headers: {
				'Content-Type': 'application/json; charset=utf-8'
			},
			body: JSON.stringify(this.payload),
		}).then(r => r.blob()).then(this.showFile.bind(this));
	}

	showFile(blob) {
		const newBlob = new Blob([blob], { type: 'application/pdf' });
		if (window.navigator && window.navigator.msSaveOrOpenBlob) {
			window.navigator.msSaveOrOpenBlob(newBlob);
			return;
		}
		const data = window.URL.createObjectURL(newBlob);
		let link = document.createElement('a');
		link.href = data;
		link.download = this.clientCode + '.pdf';
		link.click();
		setTimeout(() => {
			window.URL.revokeObjectURL(data);
			this.reset();
		}, 100);
	}

	reset() {
		this.payload.img = '';
		const fancy = this.wrapper.querySelector('[data-configurator-fancy]');
		fancy.classList.remove('loading');
	}

	updateData(clientcode, metadata) {
		this.metadata = metadata;
		this.clientCode = clientcode;
		this.payload = this.getPayload();
	}
}
